<template>
  <v-container id="shots-table-id" ref="shotsTableRef" fluid class="pa-0 overflow-visible">
    <v-row>
      <v-col cols="12" class="d-flex flex-column align-start py-0">
        <v-data-table
          :headers="headers"
          :items="shots"
          class="elevation-0 w-100"
          dense
          mobile-breakpoint="0"
          calculate-widths
        >
          <template v-slot:item.player="{ item }">
            <div class="d-flex align-center">
              <span class="body-2">
                <router-link :to="'/player/' + item.playerId">{{ item.player }}</router-link>
              </span>
            </div>
          </template>
          <!--  -->
          <template v-slot:item.playerFromName="{ item }">
            <div class="d-flex align-center">
              <span class="body-2">
                <router-link :to="'/player/' + item.playerFromId">{{ item.playerFromName }}</router-link>
              </span>
            </div>
          </template>
          <template v-slot:item.teamName="{ item }">
            <div class="d-flex align-center">
              <img
                :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + item.teamId + '.png'"
                style="height: 22px; width: 22px;"
                class="mr-2"
              />
              <span class="body-2">
                <router-link :to="'/team/' + item.teamId">{{ item.teamName }}</router-link>
              </span>
            </div>
          </template>
          <!--  -->
          <template v-slot:item.min="{ item }">
            <div class="d-flex align-center">
              <span class="body-2">
                {{item.min}}:{{item.sec > 9 ? item.sec : `0${item.sec}`}}
              </span>
            </div>
          </template>
          <!--  -->
          <template v-slot:item.typeLabel="{ item }">
            <div class="d-flex align-center">
              <span class="body-2">
                <v-icon small class="mr-1" v-if="item.eventTypeId === 16">sports_soccer</v-icon>
                {{item.typeLabel}}
                <span v-if="item.ownGoal"> {{$t('team.trendsTab.ownGoals')}}</span>
                <span v-if="item.penaltyGoal"> - {{$t('videoHighlights.qualifierIds.9')}}</span>
                <span></span>
              </span>
            </div>
          </template>
          <!--  -->
          <template v-slot:item.xG="{ item }">
            <div class="d-flex align-center w-100 h-100 justify-center" v-bind:style="{'background-color':getBackgroundColor(item,'xG')}">
              <span class="body-2">
                {{item.xG.toFixed(2)}}
              </span>
            </div>
          </template>
          <!--  -->
          
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { userHasRole } from '../../utils/functions';


export default {
  name: "ShotsTable",
  components: {},
  props: {
    shots: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
    };
  },
  created() {},
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    headers(){
      return [
        {
          text: this.$t("general.player"),
          align: "left",
          sortable: true,
          value: "player",
          width:"130"
        },
        {
          text: this.$t("team.assistant"),
          align: "left",
          sortable: true,
          value: "playerFromName",
          width:"130"
        },
        {
          text: this.$t("general.team"),
          align: "left",
          sortable: true,
          value: "teamName",
          width:"100"
        },
        {
          text: "Min.",
          align: "left",
          sortable: true,
          value: "min",
          width:"75"
        },
        {
          text: this.$t('table.usersOfClient.type'),
          align: "left",
          sortable: true,
          value: "typeLabel",
          width:"60",
          cellClass:"px-0"
        },
        {
          text: this.$t('finishingMap.areas'),
          align: "left",
          sortable: true,
          value: "areaLabel",
          width:"120"
        },
        {
          text: this.$t('finishingMap.bodyPart'),
          align: "left",
          sortable: true,
          value: "bodyPart",
          width:"100"
        },
        {
          text: this.$t('charts.xGLabel'),
          align: "left",
          sortable: true,
          value: "xG",
          width:"70"
        },
      ]
    },
    currentUserLanguage() {
      return this.$store.getters["auth/language"];
    },
  },
  mounted() {},
  methods: {
    getBackgroundColor(item,property){
      let allData = _.map(this.shots,(s) => s[property]);
      let max = _.max(allData);
      let min = _.min(allData);
      let data = item[property];
      let percentageOfColor = (data - min) / (max - min);

      return `rgba(51, 102, 255,${percentageOfColor / 2})`;
    },
    getBackgroundColorByXG(item){
      return `background-color: ${this.getBackgroundColor(item,'xG')}`;
    }
  }
};
</script>

<style lang="scss">
</style>
